import { Paper, Typography } from '@mui/material';
import React from 'react';
import { useTranslate } from 'react-admin';
import CustomInput from '../../components/customInput/CustomInput';
import MyCustomImageUploader from '../../components/imageInput/MyCustomImageUploader';
import { SettingModel } from '../../config/types/models/SettingModel';
import { useAwsUpload } from '../../dataProviders/useAwsUpload';

type IProps = {
  setting: SettingModel;
  setSetting: (s: SettingModel) => void;
};

function EmailSetting({ setting, setSetting }: IProps) {
  const t = useTranslate();
  const { loading, upload } = useAwsUpload();

  return (
    <Paper sx={{ padding: 2, marginTop: 2 }}>
      <Typography variant='subtitle2'>{t('EmailSetting')}</Typography>
      <CustomInput
        value={setting?.EMAIL_SMTP_HOST || ''}
        onChange={(e) => {
          setSetting({ ...setting, EMAIL_SMTP_HOST: e.target.value });
        }}
        label={t('EMAIL_SMTP_HOST')}
      />

      <CustomInput
        value={setting?.EMAIL_SMTP_HOST_PORT || ''}
        onChange={(e) => {
          setSetting({ ...setting, EMAIL_SMTP_HOST_PORT: e.target.value });
        }}
        label={t('EMAIL_SMTP_HOST_PORT')}
      />

      <CustomInput
        value={setting?.EMAIL_SENDER || ''}
        onChange={(e) => {
          setSetting({ ...setting, EMAIL_SENDER: e.target.value });
        }}
        label={t('EMAIL_SENDER')}
      />

      <CustomInput
        value={setting?.EMAIL_SENDER_PASSWORD || ''}
        onChange={(e) => {
          setSetting({ ...setting, EMAIL_SENDER_PASSWORD: e.target.value });
        }}
        label={t('EMAIL_SENDER_PASSWORD')}
      />
    </Paper>
  );
}

export default EmailSetting;
